import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatesRequest } from '../store/addressSlice';
import {
  selectStates,
  selectStatesLoading,
  selectStatesCountry,
} from '../store/addressSelectors';


export function useStates(section, country) {
  const dispatch = useDispatch();
  const states = useSelector(selectStates(section));
  const loading = useSelector(selectStatesLoading(section));
  const cachedCountry = useSelector(selectStatesCountry(section));

  useEffect(() => {
    if (!section || !country) return;
    if (cachedCountry === country) return;
    dispatch(fetchStatesRequest({ section, country }));
  }, [dispatch, section, country, cachedCountry]);

  return { states, loading };
}
